import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import authSlice from "../features/authSlice";
import teamSlice from "../features/teamSlice";
import jobSlice from "../features/jobSlice";
import applicantSlice from "../features/applicantSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    team: teamSlice,
    job: jobSlice,
    applicant: applicantSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const useAppDispatch: () => typeof store.dispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<
  ReturnType<typeof store.getState>
> = useSelector;
